module.exports = __webpack_public_path__ + "static/media/sn-1500c.191d9dc9.jpg";